import React, { useRef } from 'react';
import './HeroBanner.css';
import floralDesign1 from '../assets/Links/Floral_Pattern_1.svg';
import floralDesign2 from '../assets/Links/Floral_Pattern_2.svg';
import bagImage from '../assets/Links/Main_Rice_bag.png';
import Homepage from '../pages/Homepage';
import NavBar from '../components/NavBar';
import ScrollArrow from '../components/ScrollArrow';
import BackToTop from '../components/BackToTop';

const HeroBanner = () => {
  const nextSectionRef = useRef(null);

  const scrollToNextSection = () => {
    if (nextSectionRef.current) {
      nextSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section>
      <div className="hero-overall-wrapper">
      <NavBar />

      <div className="hero-wrapper">
        <div className="hero-content">
          <div className="floral-design1">
            <img src={floralDesign1} alt="Floral Design" />
          </div>
          <h1 className="welcome">Welcome</h1>
          <h1 className="brand">SHRIVEL</h1>
          <p className="stretched-text">HITECH RICE INDUSTRIES</p>
          <div className="floral-design2">
            <img src={floralDesign2} alt="Floral Design" />
          </div>
          <p>Mother’s Choice</p>
        </div>

        <div className="hero-image">
          <img src={bagImage} alt="Mr. Butler rice bags" />
        </div>
      </div>

      <ScrollArrow onClick={scrollToNextSection} />
           <BackToTop/>

      <section ref={nextSectionRef} className="home-page">
        <Homepage />
      </section>
      </div>
    </section>
  );
};

export default HeroBanner;
